import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------
//  Footer
// ----------------------------------------------------------------------
const Footer = ({
  color = null,
  // Add more props here
}) => {
  const [bgColor, setBgColor] = useState(color);

  const { t } = useTranslation();

  useEffect(() => {
    setBgColor(color);
  }, [color]);

  // --------------------------------------------------------------------------------------------
  // Render
  // --------------------------------------------------------------------------------------------
  return (
    <footer className={`footer ${bgColor} w-full`}>
      <div className="flex w-full flex-col justify-between gap-4 border-t border-gray-200 py-8 dark:border-gray-700 lg:flex-row lg:gap-0">
        <div className="footer-trademark">
          <a target="_blank" href="https://www.kincode.ai">
            &copy; Kincode AI {new Date().getFullYear()}
          </a>
        </div>
        <div className="footer-links ">
          <a
            target="_blank"
            className="hover:underline"
            href="https://kincode.ai/terms-and-conditions"
          >
            {t('footer.terms-and-conditions')}
          </a>
          <a target="_blank" className="hover:underline" href="https://kincode.ai/privacy-policy">
            {t('footer.privacy-policy')}
          </a>
          <a target="_blank" className="hover:underline" href="https://status.kincode.ai">
            {t('footer.status')}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
